
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.7 8A7.7 7.7 0 11.3 8a7.7 7.7 0 0115.4 0zM8 15A7 7 0 108 1a7 7 0 000 14z","fill":"#8E8E8E"}}),_c('path',{attrs:{"d":"M8.45 9.959H7.432c.004-.35.035-.637.093-.859.062-.226.163-.432.301-.618.139-.186.323-.397.552-.634.168-.172.321-.332.46-.482.142-.153.257-.317.344-.492.088-.178.132-.392.132-.64a1.44 1.44 0 00-.137-.65.937.937 0 00-.394-.421 1.268 1.268 0 00-.64-.148c-.211 0-.412.038-.601.115-.19.076-.343.195-.46.355-.116.157-.176.363-.18.618H5.89c.007-.412.11-.765.306-1.06.2-.296.47-.522.81-.679.339-.157.718-.235 1.137-.235.463 0 .857.084 1.182.251.328.168.577.409.749.722.171.31.257.678.257 1.105 0 .328-.068.63-.203.908-.13.273-.3.53-.508.77-.208.242-.429.471-.662.69-.2.186-.335.396-.405.629a2.64 2.64 0 00-.103.755zm-1.061 1.733c0-.164.05-.302.153-.415.102-.113.25-.17.443-.17.197 0 .346.057.448.17a.597.597 0 01.153.415.583.583 0 01-.153.405c-.102.113-.251.17-.448.17-.194 0-.341-.057-.443-.17a.583.583 0 01-.153-.405z","fill":"#8E8E8E"}})])
          )
        }
      }
    